import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IUsr0101MState, IUserItemState, IOffrDcdItemState, IOffStatusState, IUserOffHisState, IInquiryCndsState, IDeptCdItemState, ICalendarState } from '../../models/usr/usr0101m_model';
  
const initialState: IUsr0101MState = {
    userOffStatus: {},      // 휴가현황정보
    userList: [],           // 사용자정보 
    userOffHis: [],         // 휴가이력
    offrDcdList: [],        // 휴가구분목록
    deptCdList: [],         // 부서코드목록
    calendarInfoList: [],   // 일자정보목록

    inquiryCnds: {
        empNo   : '',       // 사원번호
        userNm  : '',       // 사원명
        offStDt : '',       // 시작일자
        offEdDt : '',       // 종료일자
        offDcd  : '',       // 휴가구분
        deptCd  : '',       // 부서코드
        baseYy  : commonDate.maskDate(commonDate.getToday(), 'YYYY'),       // 기준년
        baseYm  : commonDate.maskDate(commonDate.getToday(), 'YYYYMM')      // 기준년월
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current : 0,            // 현재페이지
}

export const usr0101m_Slice = createSlice({
    name: "usr0101m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state, action:PayloadAction<IInquiryCndsState>) => {
            return {
                ...state,
                inquiryCnds : { ...initialState.inquiryCnds, ...action.payload },
                userOffHis  : initialState.userOffHis,
            }
        },
        setUserOffStatus: (state, action:PayloadAction<IOffStatusState>) => {
            state.userOffStatus = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setUserOffHis: (state, action:PayloadAction<IUserOffHisState[]>) => {
            state.userOffHis = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdItemState[]>) => {
            state.deptCdList = action.payload;
        },
        setOffrDcdList: (state, action:PayloadAction<IOffrDcdItemState[]>) => {
            state.offrDcdList = action.payload;
        },
        setCalendarInfoList: (state, action:PayloadAction<ICalendarState[]>) => {
            state.calendarInfoList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default usr0101m_Slice.reducer;
export const Usr0101mAction  = usr0101m_Slice.actions;
export const Usr0101mReducer = usr0101m_Slice.reducer;